import { apiCall, API_CONFIG } from './api';

export const chatAPI = {
  // Get all chats with pagination and filters
  getAllChats: async (page = 1, limit = 20, status = '', topic = '', subtype = '', userId = '') => {
    try {
      const queryParams = new URLSearchParams();

      if (page) queryParams.append('page', page);
      if (limit) queryParams.append('limit', limit);
      if (status) queryParams.append('status', status);
      if (topic) queryParams.append('topic', topic);
      if (subtype) queryParams.append('subtype', subtype);
      if (userId) queryParams.append('userId', userId);

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.CHATS_LIST}?${queryParams.toString()}`,
        { method: 'GET' }
      );

      if (response.success) {
        return {
          success: true,
          data: response.data,
          msg: response.message || 'Chats fetched successfully',
        };
      } else {
        return {
          success: false,
          error: response.message || 'Failed to fetch chats',
        };
      }
    } catch (error) {
      console.error('Error fetching chats:', error);
      return {
        success: false,
        error: 'Error fetching chats: ' + error.message,
      };
    }
  },

  // Get chat detail by ID
  getChatById: async (chatId) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.CHAT_DETAIL}/${chatId}`,
        { method: 'GET' }
      );

      if (response.success) {
        return {
          success: true,
          data: response.data,
          msg: response.message || 'Chat fetched successfully',
        };
      } else {
        return {
          success: false,
          error: response.message || 'Failed to fetch chat',
        };
      }
    } catch (error) {
      console.error('Error fetching chat:', error);
      return {
        success: false,
        error: 'Error fetching chat: ' + error.message,
      };
    }
  },

  // Update chat status (active / closed)
  updateChatStatus: async (chatId, status) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.CHAT_UPDATE_STATUS}/${chatId}`,
        {
          method: 'PUT',
          body: JSON.stringify({ status }),
        }
      );

      if (response.success) {
        return {
          success: true,
          data: response.data,
          msg: response.message || 'Chat status updated successfully',
        };
      } else {
        return {
          success: false,
          error: response.message || 'Failed to update chat status',
        };
      }
    } catch (error) {
      console.error('Error updating chat status:', error);
      return {
        success: false,
        error: 'Error updating chat status: ' + error.message,
      };
    }
  },

  // Send message to a chat (admin)
  sendMessage: async (chatId, text, media = [], products = []) => {
    try {
      const formData = new FormData();
      if (text) formData.append('text', text);

      if (media && media.length > 0) {
        media.forEach((file) => {
          formData.append('media', file);
        });
      }

      if (products && products.length > 0) {
        formData.append('products', JSON.stringify(products));
      }

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.CHAT_SEND_MESSAGE}/${chatId}`,
        {
          method: 'POST',
          body: formData,
        }
      );

      if (response.success) {
        return {
          success: true,
          data: response.data,
          msg: response.message || 'Message sent successfully',
        };
      } else {
        return {
          success: false,
          error: response.message || 'Failed to send message',
        };
      }
    } catch (error) {
      console.error('Error sending message:', error);
      return {
        success: false,
        error: 'Error sending message: ' + error.message,
      };
    }
  },
};